import type EnType from '../en-US/api';

export default {
  'api.label.authorization.inheritLabel': 'Ver autorização {type} desta API',
  'api.label.authorization.inheritLabel.folder': 'Herdado do grupo [{folderName}]',
  'api.label.authorization.inheritLabel.project': 'Herdado do projeto',

  'api.label.authorization.description.apikey':
    'Adicionar parâmetro em {position} <div class="locals-tag">{key}</div>',
  'api.label.authorization.description.bearer':
    'Forneça seu token bearer no cabeçalho <div class="locals-tag">Authorization</div> ao fazer requisições para recursos protegidos.',
  'api.label.authorization.description.basic':
    'Envie suas requisições HTTP com um cabeçalho <div class="locals-tag">Authorization</div> que contenha a palavra Basic seguida por um espaço e uma string codificada em base64 <span class="ui-tag whitespace-normal break-all"><code>username:password</code></span>',
  'api.label.authorization.description.digest':
    'Forneça seus dados de esquema digest criptografados no cabeçalho <div class="locals-tag">Authorization</div> ao fazer requisições para recursos protegidos.',
  'api.label.authorization.description.hawk':
    'Forneça seus dados de esquema Hawk criptografados no cabeçalho <div class="locals-tag">Authorization</div> ao fazer requisições para recursos protegidos.',
  'api.label.authorization.description.aws':
    'Adicionar parâmetros <div class="locals-tag">Authorization</div> e <div class="locals-tag">X-Amz-Date</div> ao Cabeçalho',
  'api.label.authorization.description.aws.url':
    'Adicionar informações do parâmetro <div class="locals-tag">Authorization</div> e <div class="locals-tag">X-Amz-Date</div> na URL',
  'api.label.authorization.description.edgegrid':
    'Adicionar o parâmetro <div class="locals-tag">Authorization</div> ao Cabeçalho, cujo valor é concatenar o esquema de criptografia digest após EG1-HMAC-SHA256',

  'api.label.authorization': 'Authorization',
  'api.label.parameters': 'Requisição',
  'api.label.codeSample': 'Exemplos de Requisição',
  'api.label.responses': 'Respostas',
  'api.label.example': 'Exemplo',
  'api.label.callbacks': 'Callbacks',
  'api.label.dataSchema': 'Esquemas',
  'api.auth.label.addAuthDataTo': 'Adicionar a',
  'api.auth.label.addTo': 'Adicionar a',
  'api.auth.label.more': 'Avançado',
  'api.auth.label.moreTip':
    'Estas são opções de configuração avançadas. Elas são opcionais. {appName} gerará automaticamente valores para alguns campos se deixados em branco.',
  'api.auth.label.disableRetryRequest': 'Desativar repetição da requisição',
  'api.auth.label.disableRetryRequestTip':
    'Por padrão, {appName} extrairá valores da resposta recebida, adicionará à requisição e tentará novamente. Deseja desativar isso?',
  'api.parameterLabel.name': 'Nome',
  'api.parameterLabel.example': 'Exemplo',
  'api.parameterLabel.type': 'Tipo',
  'api.parameterLabel.value': 'Valor',
  'api.parameterLabel.noNeedToDefineTheBody': 'Não é necessário definir o Body',
  'api.parameterLabel.noNeedToDefineTheResponse': 'Não é necessário definir a Resposta',
  'message.hasNoResponseBody': 'Esta resposta não possui corpo.',
  'api.parameterLabel.file.disabled.tip':
    'O tipo de arquivo não é suportado quando o Body é x-www-form-urlencode, por favor use form-data',
  'api.status.designing': 'Em design',
  'api.status.pending': 'Pendente',
  'api.status.developing': 'Em desenvolvimento',
  'api.status.integrating': 'Em integração',
  'api.status.testing': 'Em teste',
  'api.status.tested': 'Testado',
  'api.status.released': 'Lançado',
  'api.status.deprecated': 'Será Depreciado',
  'api.status.exception': 'Exceção',
  'api.status.obsolete': 'Obsoleto',
  'api.automaticGenerated': 'Geração automática',
  'response.label.headers': 'Headers',
  'response.label.body': 'Body',
  'response.label.contentType': 'Tipo de Conteúdo',
  'api.auth.beginnerTips':
    'A autorização adicionada aqui será aplicada a todas as requisições deste grupo e pode ser modificada em requisições específicas',
  'api.auth.label.type': 'Tipo',
  'quickDebug.placeHolder.error': 'Formato de URL Incorreto, {detail}',
  'quickDebug.placeHolder.detail': 'Digite a URL completa começando com http ou https',
  'parameter.count.none': 'Nenhum',
  'api.requestBody.binary.uploaded': 'Arquivo Enviado',
  'api.requestBody.binary.notConfigured': 'Não configurado',
  'api.request.auth.jwt.algorithm.label': 'Algoritmo',
  'api.request.auth.jwt.secret.label': 'Segredo',
  'api.request.auth.jwt.isSecretBase64Encoded.label': 'Segredo está codificado em Base64',
  'api.request.auth.jwt.payload.label': 'Payload',
  'api.request.auth.jwt.headerPrefix.label': 'Prefixo de Autorização HTTP',
  'api.request.auth.jwt.header.label': 'Cabeçalho JWT Personalizado',
  'api.request.auth.jwt.privateKey.label': 'Chave Privada',
  'api.request.auth.jwt.privateKey.button.label': 'Escolher Arquivo',
  'api.request.auth.jwt.queryParamKey.label': 'Nome do Parâmetro de Consulta',
  'api.request.auth.jwt.algorithm.placeholder': 'Por favor, selecione um algoritmo',
  'api.request.auth.jwt.secret.placeholder': 'Segredo',
  'api.request.auth.jwt.payload.placeholder': 'Compor com JSON',
  'api.request.auth.jwt.headerPrefix.placeholder': 'Prefixo de Autorização HTTP',
  'api.request.auth.jwt.header.placeholder': 'Compor com JSON',
  'api.request.auth.jwt.privateKey.placeholder':
    '-----BEGIN PRIVATE KEY-----\nPrivate key in PKCS#8 PEM format\n-----END PRIVATE KEY-----',
  'api.request.auth.jwt.queryParamKey.placeholder': 'Nome do Parâmetro de Consulta',
  'api.label.authorization.jwt.description1':
    'Adicionar o parâmetro <div class="locals-tag">{name}</div> a {addTokenTo}',
  'api.label.authorization.jwt.description2':
    ', cujo valor é concatenar o Token após o {headerPrefix}.',

  'api.label.authorization.oauth2.httpAuthorizationPrefix.label': 'Prefixo de Autorização HTTP',
  'api.label.authorization.oauth2.grantType.label': 'Tipo de Concessão',
  'api.parameterLabel.contentType': 'Content-Type',
  'message.bodyParameter': 'Parâmetros Body',
  'message.queryParameter': 'Parâmetros Query',
  'message.pathParameter': 'Parâmetros Path',
  'message.headerParameter': 'Parâmetros Header',
  'message.cookieParameter': 'Parâmetros Cookie',
  'message.hasNoBodyParameter': 'Esta requisição não tem construção de corpo',
  'modified.at.label': 'Modificado em',
  'built.with': 'Built with',
  slogan: 'All-in-One API Platform: Design, Debug, Mock, Test, and Document',
  'doc.anchor.title': 'Nesta página',
  'http.status.code.tooltip': 'HTTP Status Code',
  examples: 'Examples',
  'api.auth.securitySchemeUseCase.valueAssignment.inherit.title':
    'Usar Valores de Autenticação Padrão do Pai',
  'api.auth.securitySchemeUseCase.valueAssignment.inherit.desc':
    'Usar os valores de autenticação padrão configurados na pasta pai.',
  'api.auth.securitySchemeUseCase.valueAssignment.override.title': 'Definir Manualmente',
  'api.auth.securitySchemeUseCase.valueAssignment.override.desc':
    'Configurar manualmente os valores necessários para autorização.',
  'api.auth.folderSecuritySchemeUseCase.defaultValue': 'Valores de Autenticação Padrão',
  'api.auth.securitySchemeDefinition.more': 'E {count} outros.',
  'api.auth.securitySchemeDefinition.notToAuth': 'Não Autenticar',
  'api.auth.securitySchemeUseCase.valueIn': 'Em {in}',
  'api.label.sourceUrl': ' Link original',
  'api.label.operationId': 'OperationId',
  'api.customAuth.error.message.title': 'Erro',
  'api.customAuth.redirect.title': 'Redirecionando...',
  'api.action.mcp.modal.description':
    'Permitir que ferramentas como o Cursor acessem o site completo da documentação da API para codificação assistida por IA.',
  'api.action.mcp.modal.editor.other': 'Outros',
  'api.action.mcp.modal.cursor.copy': 'Configuração com um clique',
  'api.action.mcp.modal.cursor.or': 'ou',
  'api.action.mcp.modal.cursor.manualCopy': 'Configuração manual',
  'api.action.mcp.modal.cursor.button.text': 'Clique aqui para adicionar ao Cursor',
  'api.action.mcp.modal.cursor.version': 'Suporta apenas a versão 1.0 do Cursor e superiores',
  'api.action.mcp.modal.commandTip':
    'Nota: O ambiente Node.js deve estar instalado (versão >= 18).',
  'api.action.mcp.modal.footer.question': 'Como usar o MCP após copiar o JSON?',
  'api.action.mcp.modal.footer.help': 'Ver documentação de ajuda',
  'api.action.mcp.modal.command.doc': 'Documentação da API',
} satisfies typeof EnType;
